module.exports = __webpack_public_path__ + "img/flavor11.1d74a58f.svg";